(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["inn-free-shipping"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('inn-free-shipping')) {
  class InnFreeShipping extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      const configNode = this.querySelector('[data-inn-shipping-config]');
      if (!configNode) return;
      this.config = JSON.parse(configNode.textContent);
      this.threshold = Number(this.config.threshold);
      this.variants = new Map(this.config.variants.map((variant) => [String(variant.id), variant]));
      this.cart = this.config.cart;
      this.sizeSelected = false;
      this.pendingAnnounce = false;
      this.sizeOptions = this.config.options.filter((option) => /velicin|size|broj/.test(this.normalize(option.name)));
      this.revision = 0;
      this.initialized = true;
      this.complete = undefined;
      this.renderedState = '';
      this.titleNode = this.querySelector('[data-inn-shipping-title]');
      this.descriptionNode = this.querySelector('[data-inn-shipping-description]');
      this.progressNode = this.querySelector('[role="progressbar"]');
      this.fillNode = this.progressNode.querySelector('span');
      this.truckNode = this.querySelector('[data-inn-shipping-truck]');
      this.checkNode = this.querySelector('[data-inn-shipping-check]');
      this.onCart = (event) => {
        const cart = event.detail?.cart;
        if (this.validCart(cart)) {
          this.revision++;
          this.requestController?.abort();
          this.cart = cart;
          this.update(true);
        } else {
          this.refresh(true);
        }
      };
      this.onSelection = (event) => {
        const target = event.target;
        if (!(target instanceof Element) || target.closest('inn-socks-upsell')) return;
        const root = this.productRoot || document.querySelector('.product-template__info');
        if (!root?.contains(target)) return;
        const control = this.sizeControl(target);
        const chosen = event.isTrusted && control && !control.disabled && (
          control.matches('input[type="radio"]') && control.checked
          || control.matches('select') && event.type === 'change'
        );
        if (chosen) this.sizeSelected = Boolean(control.value);
        this.scheduleUpdate(Boolean(chosen));
        clearTimeout(this.selectionTimer);
        this.selectionTimer = setTimeout(() => this.scheduleUpdate(Boolean(chosen)), 150);
      };
      this.onPageShow = (event) => {
        if (event.persisted) {
          this.scheduleUpdate();
          this.refresh(false);
        }
      };
      this.onVisibility = () => {
        if (document.visibilityState === 'visible') this.refresh(false);
      };
      this.onSectionLoad = () => {
        this.bindProductRoot();
        this.scheduleUpdate();
      };
      this.bindProductRoot();
      this.update(false);
      document.addEventListener('cart:updated', this.onCart);
      document.addEventListener('change', this.onSelection, true);
      document.addEventListener('input', this.onSelection, true);
      document.addEventListener('click', this.onSelection, true);
      document.addEventListener('visibilitychange', this.onVisibility);
      document.addEventListener('shopify:section:load', this.onSectionLoad);
      window.addEventListener('pageshow', this.onPageShow);
    }

    disconnectedCallback() {
      document.removeEventListener('cart:updated', this.onCart);
      document.removeEventListener('change', this.onSelection, true);
      document.removeEventListener('input', this.onSelection, true);
      document.removeEventListener('click', this.onSelection, true);
      document.removeEventListener('visibilitychange', this.onVisibility);
      document.removeEventListener('shopify:section:load', this.onSectionLoad);
      window.removeEventListener('pageshow', this.onPageShow);
      this.observer?.disconnect();
      this.requestController?.abort();
      cancelAnimationFrame(this.frame);
      clearTimeout(this.selectionTimer);
      this.revision++;
      this.hideToast();
      this.toast?.remove();
      this.toast = null;
      this.productRoot = null;
      this.initialized = false;
    }

    bindProductRoot() {
      const root = document.querySelector('.product-template__info');
      if (root === this.productRoot) return;
      this.observer?.disconnect();
      this.productRoot = root;
      if (!root) return;
      this.observer = new MutationObserver((records) => {
        if (records.some((record) => {
          const target = record.target instanceof Element ? record.target : record.target.parentElement;
          return target && !target.closest('inn-socks-upsell, inn-free-shipping');
        })) this.scheduleUpdate();
      });
      this.observer.observe(root, {
        childList: true, subtree: true, attributes: true,
        attributeFilter: ['value', 'checked', 'selected']
      });
    }

    normalize(value) {
      return String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim().toLowerCase();
    }

    sizeControl(target) {
      const label = target.closest('label');
      const control = target.closest('input, select') || label?.control || label?.querySelector('input, select');
      if (!control || !this.productRoot?.contains(control)) return null;
      if (!control.matches('input[type="radio"], select') || control.closest('inn-socks-upsell')) return null;
      const name = this.normalize(control.name);
      const group = control.closest('[data-option]')?.getAttribute('data-option');
      const matches = this.sizeOptions.some((option) => {
        const optionName = this.normalize(option.name);
        return name === optionName || name === 'options[' + optionName + ']'
          || name === 'name' + (Number(option.position) - 1)
          || group === 'option' + option.position;
      });
      return matches || name === 'id' && this.sizeOptions.length ? control : null;
    }

    scheduleUpdate(announce = false) {
      this.pendingAnnounce = this.pendingAnnounce || announce;
      cancelAnimationFrame(this.frame);
      this.frame = requestAnimationFrame(() => {
        if (!this.isConnected) return;
        const announceUpdate = this.pendingAnnounce;
        this.pendingAnnounce = false;
        this.bindProductRoot();
        this.update(announceUpdate);
      });
    }

    selectedProduct() {
      const root = this.productRoot || document.querySelector('.product-template__info');
      const form = root?.querySelector('product-form form[data-type="add-to-cart-form"]')
        || root?.querySelector('product-form form');
      const controls = form ? Array.from(form.elements) : [];
      const idControl = controls.find((control) => control.name === 'id'
        && (control.type !== 'radio' || control.checked));
      const quantityControl = controls.find((control) => control.name === 'quantity');
      const variant = this.variants.get(String(idControl?.value))
        || this.variants.get(String(this.config.variantId));
      const quantity = Number(quantityControl?.value || 1);
      return {
        variant,
        quantity: Number.isSafeInteger(quantity) && quantity > 0 ? quantity : 1
      };
    }

    validCart(cart) {
      return Boolean(cart && Number.isFinite(cart.total_price) && Array.isArray(cart.items));
    }

    displayedTotal() {
      if (!this.sizeSelected) return this.cart.total_price;
      const { variant, quantity } = this.selectedProduct();
      if (!variant || !Number.isFinite(variant.price)) return this.cart.total_price;
      const alreadyInCart = this.cart.items.reduce((sum, item) => {
        return String(item.variant_id) === String(variant.id) ? sum + Number(item.quantity || 0) : sum;
      }, 0);
      const missingQuantity = Math.max(0, quantity - alreadyInCart);
      return this.cart.total_price + missingQuantity * variant.price;
    }

    money(cents) {
      if (this.config.currency === 'BAM') return (cents / 100).toFixed(2).replace('.', ',') + ' KM';
      return new Intl.NumberFormat(this.config.locale, {
        style: 'currency', currency: this.config.currency
      }).format(cents / 100);
    }

    async refresh(announce) {
      const revision = ++this.revision;
      this.requestController?.abort();
      const controller = new AbortController();
      this.requestController = controller;
      const timer = setTimeout(() => controller.abort(), 10000);
      try {
        const response = await fetch(this.config.root + 'cart.js', {
          credentials: 'same-origin', cache: 'no-store',
          headers: { Accept: 'application/json' }, signal: controller.signal
        });
        if (!response.ok) return;
        const cart = await response.json();
        if (this.isConnected && revision === this.revision && this.validCart(cart)) {
          this.cart = cart;
          this.update(announce);
        }
      } catch (error) {
        if (error.name !== 'AbortError') console.warn('INN shipping refresh:', error.name);
      } finally {
        clearTimeout(timer);
        if (this.requestController === controller) this.requestController = null;
      }
    }

    update(announce) {
      if (!this.validCart(this.cart) || this.threshold <= 0) return;
      const total = this.displayedTotal();
      if (!Number.isFinite(total)) return;
      const actualCartComplete = this.cart.total_price >= this.threshold;
      const state = total + ':' + actualCartComplete;
      if (state === this.renderedState) return;
      this.renderedState = state;
      const previous = this.complete;
      const remaining = Math.max(0, this.threshold - total);
      this.complete = remaining === 0;
      const progress = Math.max(0, Math.min(100, total / this.threshold * 100));
      this.classList.toggle('inn-shipping--complete', this.complete);
      if (this.complete) {
        this.titleNode.textContent = this.config.completeTitle;
      } else {
        const amount = document.createElement('strong');
        amount.textContent = this.money(remaining);
        this.titleNode.replaceChildren(
          document.createTextNode(this.config.before + ' '), amount,
          document.createTextNode(' ' + this.config.after)
        );
      }
      this.descriptionNode.textContent = actualCartComplete
        ? this.config.completeDescription : this.config.description;
      this.progressNode.setAttribute('aria-valuenow', String(Math.round(progress)));
      this.progressNode.setAttribute('aria-valuetext', this.complete
        ? this.config.completeLabel : this.money(remaining) + ' ' + this.config.after);
      this.fillNode.style.width = progress + '%';
      this.truckNode.toggleAttribute('hidden', this.complete);
      this.checkNode.toggleAttribute('hidden', !this.complete);
      if (!this.complete) this.hideToast();
      if (announce && previous === false && this.complete) this.showToast();
    }

    showToast() {
      if (!this.toast) {
        this.toast = document.createElement('div');
        this.toast.className = 'inn-shipping-toast';
        this.toast.setAttribute('role', 'status');
        this.toast.setAttribute('aria-live', 'polite');
        this.toast.setAttribute('aria-atomic', 'true');
        this.toast.hidden = true;
        const icon = document.createElement('span');
        icon.className = 'inn-shipping-toast__icon';
        icon.textContent = '✓';
        icon.setAttribute('aria-hidden', 'true');
        const content = document.createElement('div');
        const title = document.createElement('strong');
        title.textContent = this.config.toastTitle;
        const message = document.createElement('span');
        message.textContent = this.config.toastMessage;
        content.append(title, message);
        this.toast.append(icon, content);
        document.body.append(this.toast);
      }
      clearTimeout(this.toastTimer);
      this.toast.hidden = false;
      this.toastTimer = setTimeout(() => this.hideToast(), 2000);
    }

    hideToast() {
      clearTimeout(this.toastTimer);
      if (this.toast) this.toast.hidden = true;
    }
  }
  customElements.define('inn-free-shipping', InnFreeShipping);
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["inn-socks-upsell"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('inn-socks-upsell')) {
  class InnSocksUpsell extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      try {
        this.config = JSON.parse(this.querySelector('[data-inn-socks-config]').textContent);
        this.text = this.config.text;
        this.root = this.closest('.product-template__info');
        this.status = this.querySelector('[data-inn-socks-status]');
        this.grid = this.querySelector('[data-inn-socks-list]');
        this.busy = false;
        const products = this.chooseProducts(this.config.products);
        if (!products.length || !this.root) return;
        products.forEach((product) => this.renderCard(product));
        this.hidden = false;
        this.querySelector('[data-inn-socks-checkout]').addEventListener('click', () => this.checkout());
        this.onMainClick = (event) => {
          const button = event.target.closest('[name="add"]');
          if (!button || button.form !== this.mainForm) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          if (!this.busy) this.addMainItem();
        };
        this.onMainSubmit = (event) => {
          if (event.target !== this.mainForm) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          if (!this.busy) this.addMainItem();
        };
        this.root.addEventListener('click', this.onMainClick, true);
        this.root.addEventListener('submit', this.onMainSubmit, true);
        this.bindBuyNow();
        this.observer = new MutationObserver((records) => {
          if (records.every((record) => this.contains(record.target))) return;
          if (this.frame) return;
          this.frame = requestAnimationFrame(() => {
            this.frame = null;
            this.bindBuyNow();
          });
        });
        this.observer.observe(this.root, { childList: true, subtree: true });
      } catch (error) {
        this.hidden = true;
        console.error('INN socks:', error);
      }
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.root?.removeEventListener('click', this.onMainClick, true);
      this.root?.removeEventListener('submit', this.onMainSubmit, true);
      if (this.frame) cancelAnimationFrame(this.frame);
    }

    chooseProducts(products) {
      const source = this.config.tags;
      const childOnly = source.includes('za-djecu') && !source.includes('za-zene') && !source.includes('za-muskarce');
      const genders = ['za-zene', 'za-muskarce'].filter((tag) => source.includes(tag));
      let pool = products.filter((product) => {
        if (!product.image || !product.variants.length) return false;
        const tags = product.tags;
        if (childOnly) return tags.includes('za-djecu');
        const onlyChildren = tags.includes('za-djecu') && !tags.includes('za-zene') && !tags.includes('za-muskarce');
        if (onlyChildren) return false;
        return !genders.length || tags.includes('unisex') || genders.some((tag) => tags.includes(tag)) || !['za-zene', 'za-muskarce', 'za-djecu'].some((tag) => tags.includes(tag));
      });
      if (this.config.kind === 'hats') {
        pool = pool.filter((product) => {
          const tags = product.tags;
          return (tags.includes('kapa') || tags.includes('kape')) &&
            !tags.includes('plivanje') && !tags.includes('kacket') && !tags.includes('kacketi') &&
            !/rukavic|maska|balaklav|balaclava|ka[cč]ket|swim/i.test(product.title);
        });
      }
      const football = source.includes('patike-za-fudbal') || source.includes('kopacke');
      const boots = source.includes('cizme') || source.includes('skijanje');
      const preferred = pool.filter((product) => (football || !product.tags.includes('stucne')) && (boots || !/\bski\b/i.test(product.title)));
      if (this.config.kind !== 'hats' && preferred.length >= 3) pool = preferred;
      const unique = Array.from(new Map(pool.map((product) => [product.id, product])).values());
      for (let index = unique.length - 1; index > 0; index--) {
        const target = Math.floor(Math.random() * (index + 1));
        [unique[index], unique[target]] = [unique[target], unique[index]];
      }
      return unique.slice(0, 3);
    }

    money(cents) {
      const amount = cents / 100;
      if (this.config.currency === 'BAM') return amount.toFixed(2).replace('.', ',') + ' KM';
      return new Intl.NumberFormat(this.config.locale, { style: 'currency', currency: this.config.currency }).format(amount);
    }

    element(tag, className, text) {
      const element = document.createElement(tag);
      if (className) element.className = className;
      if (text) element.textContent = text;
      return element;
    }

    renderCard(product) {
      const card = this.element('article', 'inn-socks__card');
      card.dataset.socksProduct = product.id;
      const photoLink = this.element('a', 'inn-socks__photo');
      photoLink.href = product.url;
      photoLink.setAttribute('aria-label', product.title);
      const image = this.element('img');
      image.src = product.image;
      image.alt = product.title;
      image.width = 160;
      image.height = 160;
      image.loading = 'lazy';
      image.decoding = 'async';
      photoLink.append(image);
      const content = this.element('div', 'inn-socks__content');
      const heading = this.element('h3', 'inn-socks__name');
      const link = this.element('a', '', product.title);
      link.href = product.url;
      heading.append(link);
      const price = this.element('div', 'inn-socks__price', this.money(Math.min(...product.variants.map((variant) => variant.price))));
      const controls = this.element('div', 'inn-socks__controls');
      const sizeLabel = this.element('label', 'inn-socks__field');
      sizeLabel.append(this.element('span', '', this.text.size));
      const size = this.element('select', 'inn-socks__size');
      size.setAttribute('aria-label', this.text.size + ' — ' + product.title);
      size.required = true;
      const placeholder = this.element('option', '', this.text.chooseSize);
      placeholder.value = '';
      size.append(placeholder);
      product.variants.forEach((variant) => {
        const option = this.element('option', '', variant.title);
        option.value = variant.id;
        size.append(option);
      });
      sizeLabel.append(size);
      const quantityLabel = this.element('label', 'inn-socks__field inn-socks__quantity');
      quantityLabel.append(this.element('span', '', this.text.quantity));
      const quantity = this.element('input');
      quantity.type = 'number';
      quantity.min = '1';
      quantity.max = '20';
      quantity.step = '1';
      quantity.value = '1';
      quantity.inputMode = 'numeric';
      quantity.setAttribute('aria-label', this.text.quantity + ' — ' + product.title);
      quantityLabel.append(quantity);
      const button = this.element('button', 'inn-socks__add', this.text.add);
      button.type = 'button';
      button.setAttribute('aria-label', this.text.add + ' — ' + product.title);
      const message = this.element('p', 'inn-socks__message');
      message.setAttribute('role', 'status');
      message.setAttribute('aria-live', 'polite');
      size.addEventListener('change', () => {
        const variant = product.variants.find((item) => String(item.id) === size.value);
        size.setCustomValidity('');
        message.textContent = '';
        if (!variant) return;
        price.textContent = this.money(variant.price);
        quantity.max = String(Math.min(20, variant.stock));
        if (+quantity.value > +quantity.max) quantity.value = quantity.max;
      });
      if (this.config.kind === 'hats' && product.variants.length === 1) {
        size.value = String(product.variants[0].id);
        quantity.max = String(Math.min(20, product.variants[0].stock));
      }
      button.addEventListener('click', async () => {
        if (this.busy) return;
        if (!size.value) size.setCustomValidity(this.text.chooseSize);
        if (!size.reportValidity() || !quantity.reportValidity()) return;
        const variant = product.variants.find((item) => String(item.id) === size.value);
        if (!variant) return;
        const count = Number(quantity.value);
        if (!Number.isInteger(count) || count < 1 || count > variant.stock) return;
        this.setBusy(true);
        message.textContent = this.text.adding;
        try {
          await this.waitForNativeAdd();
          const cart = await this.getCart();
          const current = cart.items.filter((item) => String(item.variant_id) === String(variant.id)).reduce((sum, item) => sum + item.quantity, 0);
          if (current + count > variant.stock) throw new Error(this.text.stockChanged);
          const result = await this.addItem({ id: variant.id, quantity: count }, cart);
          await this.refreshCart(result);
          message.textContent = this.text.added;
          this.status.textContent = this.text.ready;
        } catch (error) {
          message.textContent = error.message || this.text.error;
          this.status.textContent = this.text.checkCart;
        } finally {
          this.setBusy(false);
        }
      });
      controls.append(sizeLabel, quantityLabel, button);
      content.append(heading, price, controls, message);
      card.append(photoLink, content);
      this.grid.append(card);
    }

    get mainForm() {
      return document.getElementById(this.config.formId);
    }

    bindBuyNow() {
      const wrapper = this.mainForm?.querySelector('.product-template__checkout');
      if (!wrapper || wrapper.querySelector('[data-inn-socks-buy-now]')) return;
      const button = this.element('button', 'shopify-payment-button__button shopify-payment-button__button--unbranded inn-socks__buy-now', this.text.buyNow);
      button.type = 'button';
      button.dataset.innSocksBuyNow = '';
      button.disabled = this.busy;
      button.addEventListener('click', () => this.checkout());
      wrapper.classList.add('inn-socks-checkout');
      wrapper.append(button);
    }

    setBusy(busy) {
      this.busy = busy;
      this.setAttribute('aria-busy', String(busy));
      this.querySelectorAll('button,select,input').forEach((element) => { element.disabled = busy; });
      this.root.querySelectorAll('[data-inn-socks-buy-now]').forEach((button) => { button.disabled = busy; });
    }

    async waitForNativeAdd() {
      const start = Date.now();
      while (this.mainForm?.querySelector('[name="add"]')?.classList.contains('loading')) {
        if (Date.now() - start > 10000) throw new Error(this.text.waitForCart);
        await new Promise((resolve) => setTimeout(resolve, 100));
      }
    }

    async request(path, data) {
      const response = await fetch(this.config.root + path, {
        method: data ? 'POST' : 'GET',
        credentials: 'same-origin',
        cache: 'no-store',
        headers: { 'Accept': 'application/json', ...(data ? { 'Content-Type': 'application/json' } : {}) },
        ...(data ? { body: JSON.stringify(data) } : {}),
        signal: AbortSignal.timeout(15000)
      });
      const result = await response.json();
      if (!response.ok || result.status >= 400) throw new Error(this.text.stockChanged);
      return result;
    }

    getCart() {
      return this.request('cart.js');
    }

    matchingQuantity(cart, request) {
      const normalize = (properties) => JSON.stringify(Object.entries(properties || {}).filter(([, value]) => value !== '' && value != null).sort(([a], [b]) => a.localeCompare(b)));
      return cart.items.filter((item) => String(item.variant_id) === String(request.id) && normalize(item.properties) === normalize(request.properties) && String(item.selling_plan_allocation?.selling_plan?.id || '') === String(request.selling_plan || '')).reduce((total, item) => total + item.quantity, 0);
    }

    async addItem(item, before) {
      const dropdown = document.querySelector('cart-dropdown-bubble');
      const sections = dropdown?.getSectionsToRender ? Array.from(new Set(dropdown.getSectionsToRender().map((section) => section.id))).slice(0, 5) : [];
      const desired = this.matchingQuantity(before, item) + item.quantity;
      try {
        return await this.request('cart/add.js', { items: [item], sections, sections_url: window.location.pathname });
      } catch (error) {
        let after;
        try { after = await this.getCart(); } catch { throw new Error(this.text.checkCart); }
        const actual = this.matchingQuantity(after, item);
        if (actual >= desired) return { recoveredCart: after };
        if (actual > this.matchingQuantity(before, item)) throw new Error(this.text.partial);
        throw error;
      }
    }

    async refreshCart(result) {
      let cart;
      try { cart = result.recoveredCart || await this.getCart(); } catch { return; }
      const dropdown = document.querySelector('cart-dropdown-bubble');
      if (dropdown?.renderUpdate && result.sections && Object.values(result.sections).every((html) => typeof html === 'string')) {
        try {
          dropdown.renderUpdate({ ...cart, sections: result.sections });
          dropdown.content?.classList.toggle('is-empty', cart.item_count === 0);
        } catch (error) { console.warn('INN cart display:', error); }
      }
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
    }

    mainItem() {
      const form = this.mainForm;
      if (!form) throw new Error(this.text.chooseShoe);
      const data = new FormData(form);
      const id = data.get('id');
      const variant = this.config.variants.find((item) => String(item.id) === String(id));
      const button = form.querySelector('[name="add"]');
      if (!id || !variant) throw new Error(this.text.chooseShoe);
      if (!variant.available || button?.disabled || button?.getAttribute('aria-disabled') === 'true') throw new Error(this.text.shoeUnavailable);
      if (!form.reportValidity()) throw new Error(this.text.chooseShoe);
      const terms = this.root.querySelector('terms-conditions input[type="checkbox"]');
      if (terms && !terms.checked) {
        terms.focus();
        throw new Error(this.text.terms);
      }
      const quantity = Number(data.get('quantity') || 1);
      if (!Number.isInteger(quantity) || quantity < 1) throw new Error(this.text.quantityError);
      const properties = {};
      for (const [key, value] of data.entries()) {
        const match = key.match(/^properties\[(.+)\]$/);
        if (match && typeof value === 'string' && value) properties[match[1]] = value;
      }
      return { id: Number(id), quantity, ...(Object.keys(properties).length ? { properties } : {}), ...(data.get('selling_plan') ? { selling_plan: data.get('selling_plan') } : {}) };
    }

    async addMainItem() {
      if (this.busy) return;
      this.setBusy(true);
      let locked = [];
      const button = this.mainForm?.querySelector('[name="add"]');
      const label = button?.textContent;
      try {
        await this.waitForNativeAdd();
        const item = this.mainItem();
        locked = Array.from(this.root.querySelectorAll('input:not([type="hidden"]),select,button')).filter((element) => !this.contains(element) && !element.hasAttribute('data-inn-socks-buy-now')).map((element) => [element, element.disabled]);
        locked.forEach(([element]) => { element.disabled = true; });
        if (button) button.textContent = this.text.adding;
        const before = await this.getCart();
        const result = await this.addItem(item, before);
        await this.refreshCart(result);
        this.status.textContent = this.text.shoeAdded;
        if (button) button.textContent = this.text.added;
        this.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'center' });
      } catch (error) {
        this.status.textContent = error.message || this.text.error;
        this.status.focus();
      } finally {
        locked.forEach(([element, disabled]) => { if (element.isConnected) element.disabled = disabled; });
        this.setBusy(false);
        if (button) setTimeout(() => { if (button.isConnected && !this.busy) button.textContent = label; }, 2500);
      }
    }

    async checkout() {
      if (this.busy) return;
      this.setBusy(true);
      this.status.textContent = this.text.preparing;
      let locked = [];
      try {
        await this.waitForNativeAdd();
        const item = this.mainItem();
        locked = Array.from(this.root.querySelectorAll('input:not([type="hidden"]),select,button')).filter((element) => !this.contains(element) && !element.hasAttribute('data-inn-socks-buy-now')).map((element) => [element, element.disabled]);
        locked.forEach(([element]) => { element.disabled = true; });
        const cart = await this.getCart();
        const missing = Math.max(0, item.quantity - this.matchingQuantity(cart, item));
        if (missing) await this.addItem({ ...item, quantity: missing }, cart);
        const verified = await this.getCart();
        if (this.matchingQuantity(verified, item) < item.quantity) throw new Error(this.text.checkCart);
        window.location.assign(this.config.root + 'checkout');
      } catch (error) {
        this.status.textContent = error.message || this.text.error;
        this.status.focus();
      } finally {
        locked.forEach(([element, disabled]) => { if (element.isConnected) element.disabled = disabled; });
        this.setBusy(false);
      }
    }
  }
  customElements.define('inn-socks-upsell', InnSocksUpsell);
}
  } catch(e) { console.error(e); }
})();

})();
